import React, { useMemo } from 'react';
import { StepProps } from '../../../types/RegistrationJourney';
import { API_ENDPOINTS, PhoneNumberField, replaceKeyWithValue, route, SelectOption, Stepper, StringHelpers, useDisabledContext, useLangContext, useQuery } from 'carrier-fe';
import { STEPS } from '../../../util/Constants';

function Step3({ form,pageLang, loading }: StepProps) {
   const { fields,crud } = useLangContext();
   const { disabled } = useDisabledContext();
   const { data: contactTypes, isLoading } = useQuery<{ data: SelectOption[] }>(
      route(`${API_ENDPOINTS.GENERIC.GAS_SAFE.CONTACT_TYPES}`),
      {
         method: 'GET',
      }
   );

   const isComponentLoading = useMemo(() => isLoading || loading, [isLoading,loading]);

   return (
      <Stepper.Step
         title={pageLang?.page?.steps[STEPS.STEP_3 - 1].title || 'Installation Contact Details'}
         description={
            pageLang?.page?.steps[STEPS.STEP_3 - 1].description || ''}
         loading={isComponentLoading}
      >
         <>
            {form?.Input({
               name: 'contact_type',
               type: 'select',
               label: fields.contact_type || 'Contact Type',
               placeholder: replaceKeyWithValue(crud?.placeholders?.select,'model',''),
               options: contactTypes?.data || [],
            })}
            <div className="row">
               <div className="col-12 col-md-6 ">
                  {form?.Input({
                     name: 'first_name',
                     type: 'text',
                     label: 'First Name',
                  })}
               </div>
               <div className="col-12 col-md-6 ">
                  {form?.Input({
                     name: 'last_name',
                     type: 'text',
                     label: 'Last Name',
                  })}
               </div>
            </div>
            {form?.Input({
               name: 'email',
               type: 'email',
               label: 'Email',
            })}
            <div className="col-12 mb-3">
                     <PhoneNumberField
                        noMargin
                        label={StringHelpers.title(fields.mobile_phone_number || 'Mobile number')}
                        name="mobile_phone_number"
                        value={form?.store?.mobile_phone_number ?? ''}
                        onChange={(value) =>
                           form.setValues({
                              mobile_phone_number: value,
                           })
                        }
                        disabled={disabled}
                        errorMessages={form?.errors?.mobile_phone_number}
                        prefixValue={form?.store?.mobile_phone_prefix ?? ''}
                        prefixOnChange={(value) =>
                           form.setValues({
                              mobile_phone_prefix: value,
                           })
                        }
                     />
                  </div>

                  {/* Landline Details */}
                  <div className="col-12 mb-5">
                     <PhoneNumberField
                        noMargin
                        label={StringHelpers.title(
                           fields.landline_phone_number || 'Landline number'
                        )}
                        name="landline_phone_number"
                        value={form?.store?.landline_phone_number ?? ''}
                        onChange={(value) =>
                           form.setValues({
                              landline_phone_number: value,
                           })
                        }
                        disabled={disabled}
                        errorMessages={form?.errors?.landline_phone_number}
                        prefixValue={form?.store?.landline_phone_prefix ?? ''}
                        prefixOnChange={(value) =>
                           form.setValues({
                              landline_phone_prefix: value,
                           })
                        }
                     />
                  </div>
            
         
         </>
      </Stepper.Step>
   );
}

export default Step3;
